module.exports = __webpack_public_path__ + "img/new.5a805ac7.jpg";